var map = {
	"./aeternity.svg": 6654,
	"./akashnetwork.svg": 5440,
	"./algorand.svg": 856,
	"./aptos.svg": 3889,
	"./arbitrumone.svg": 3081,
	"./avalanche.svg": 4254,
	"./avalanchep-xchain.svg": 2952,
	"./bahamut.svg": 2274,
	"./base.svg": 8657,
	"./bitcoin.svg": 6721,
	"./bitcoincash.svg": 1304,
	"./bitcoingold.svg": 8366,
	"./bitcoinsv.svg": 1679,
	"./bittensor.svg": 8749,
	"./blast.svg": 8225,
	"./bnbbeaconchain.svg": 9160,
	"./bnboptimistic.svg": 4134,
	"./boba.svg": 4705,
	"./bsc.svg": 6789,
	"./cardano.svg": 8052,
	"./casper.svg": 8942,
	"./celestia.svg": 7784,
	"./celo.svg": 8562,
	"./chia.svg": 4767,
	"./cirrus.svg": 1338,
	"./comdex.svg": 2536,
	"./conflux.svg": 7818,
	"./constellation.svg": 3661,
	"./cosmos.svg": 9367,
	"./coti.svg": 8086,
	"./cronos.svg": 9372,
	"./dash.svg": 2377,
	"./decentralizedpictures.svg": 3407,
	"./digibyte.svg": 5219,
	"./digitalbits.svg": 2454,
	"./divi.svg": 4045,
	"./dogechain.svg": 9293,
	"./dogecoin.svg": 6177,
	"./dydxchain.svg": 1674,
	"./dymension.svg": 8806,
	"./ecash.svg": 7123,
	"./ecredits.svg": 501,
	"./electroneum.svg": 350,
	"./enjin.svg": 7474,
	"./eos.svg": 7283,
	"./ethereum.svg": 5367,
	"./ethereumclassic.svg": 2449,
	"./everscale.svg": 9351,
	"./fantom.svg": 7984,
	"./filecoin.svg": 112,
	"./firo.svg": 5145,
	"./flare.svg": 3757,
	"./flow.svg": 957,
	"./fuse.svg": 9141,
	"./gnosis.svg": 6353,
	"./groestlcoin.svg": 2380,
	"./harmony.svg": 6715,
	"./hathor.svg": 945,
	"./heco.svg": 3003,
	"./hedera.svg": 6629,
	"./helium.svg": 7499,
	"./hive.svg": 1713,
	"./hyperliquid.svg": 795,
	"./icon.svg": 2993,
	"./injectiveprotocol.svg": 8198,
	"./ink.svg": 3245,
	"./internetcomputerprotocol.svg": 5040,
	"./iost.svg": 2389,
	"./iota.svg": 8509,
	"./kadena.svg": 8731,
	"./kaspa.svg": 6192,
	"./kava.svg": 1749,
	"./klever.svg": 3264,
	"./komodo.svg": 891,
	"./kusama.svg": 5859,
	"./linea.svg": 272,
	"./lisk.svg": 4373,
	"./litecoin.svg": 2183,
	"./lumia.svg": 2769,
	"./mantle.svg": 543,
	"./mantra.svg": 7418,
	"./metis.svg": 4058,
	"./monad.svg": 5385,
	"./monero.svg": 1237,
	"./moonbeam.svg": 2001,
	"./moonriver.svg": 4720,
	"./multiversx.svg": 9730,
	"./nano.svg": 704,
	"./nearprotocol.svg": 83,
	"./nem.svg": 910,
	"./neo.svg": 5426,
	"./nervos.svg": 8601,
	"./nibiruchain.svg": 3158,
	"./nimiq.svg": 2421,
	"./okb.svg": 7020,
	"./optimism.svg": 5868,
	"./osmosis.svg": 6845,
	"./partisia.svg": 9350,
	"./plume.svg": 4145,
	"./polkadot.svg": 5369,
	"./polygon.svg": 3108,
	"./polygonzkevm.svg": 1277,
	"./polymesh.svg": 2459,
	"./pulsechain.svg": 1642,
	"./radix.svg": 6191,
	"./ravencoin.svg": 9625,
	"./ripple.svg": 8467,
	"./ronin.svg": 4761,
	"./rootstock.svg": 5034,
	"./seichain.svg": 6975,
	"./seievm.svg": 4038,
	"./siacoin.svg": 3908,
	"./solana.svg": 7098,
	"./somnia.svg": 6983,
	"./stable.svg": 3075,
	"./stacks.svg": 9534,
	"./starknet.svg": 4818,
	"./stellar.svg": 912,
	"./storyprotocol.svg": 3358,
	"./stratis.svg": 8426,
	"./sui.svg": 9959,
	"./telos.svg": 5964,
	"./terraclassic.svg": 3484,
	"./tezos.svg": 660,
	"./thetanetwork.svg": 296,
	"./thorchain.svg": 7941,
	"./ton.svg": 308,
	"./tron.svg": 5986,
	"./ultra.svg": 7679,
	"./vechain.svg": 2497,
	"./venidium.svg": 6643,
	"./verge.svg": 6124,
	"./vite.svg": 7778,
	"./wax.svg": 1112,
	"./wemix.svg": 7430,
	"./xdag.svg": 7036,
	"./xdcnetwork.svg": 3582,
	"./zcash.svg": 7790,
	"./zerogravity.svg": 1689,
	"./zilliqa.svg": 5141,
	"./zilliqa2.0.svg": 6927,
	"./zksync.svg": 7524
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 444;